<template>
  <div>
    <!-- <DynamicNavDrawer
      :drawerOpen="signUpDrawerOpen"
      @drawerClosed="drawerClosed"
      :type="'signup'"
    >
      <template v-slot:content>
        <DrawerSignUp @loginClicked="loginClicked" />
      </template>
    </DynamicNavDrawer>
    <DynamicNavDrawer
      :drawerOpen="signInDrawerOpen"
      @drawerClosed="signInDrawerClosed"
      :type="'signin'"
    >
      <template v-slot:content>
        <DrawerSignIn
          @signupClicked="signup"
          :drawerOpen="signInDrawerOpen"
          @successResetPassword="successResetPassword"
        />
      </template>
    </DynamicNavDrawer> -->
    <Layout :containers="containers">
      <template v-slot:header>
        <DefaultHeroBar
          :hasQuickStartCallout="true"
          :quickStartTitles="[
            {
              title: 'Estate Planning',
              routeName: 'estatePlanning',
            },
            {
              title: 'Estate Protection',
              routeName: 'estateProtection',
            },
            {
              title: 'Estate Administration',
              routeName: 'estateAdministration',
            },
          ]"
          @quickStartCardLinkClicked="quickStartCardLinkClicked"
          :heroTitle="'Decide how your legacy will be honoured.'"
          :heroDescription="`Our estate solutions are tailored to protect your assets, honour your wishes, 
          and support your loved ones.`"
          :section="'ourSolutions'"
        />
      </template>

      <template v-slot:image-text-row-one>
        <Breadcrumb :ourSolutions="true" />
        <TitleRow
          :title="'Comprehensive estate solutions for peace of mind'"
          :description="`Protect your assets and loved ones. Old Mutual offers will creation, estate planning information, estate protection, and professional estate administration.`"
        />
        <ImageTextBanner
          :imageUrl="whitelabel.images.ourSolutionsOnlineWillCreation"
          :title="`<strong style='font-weight: 500'>Online will creation</strong>`"
          :paragraphOne="`Creating your will is a very personal and sometimes even emotionally challenging process.  
          That’s why Old Mutual has made it accessible and straightforward, so you can get it done with ease. Our online process guides 
          you through every step, ensuring all legal considerations are covered.
           From the comfort of your home, you’ll have expert support available whenever you need it, giving you peace of mind.`"
          :reversed="false"
          :buttonText="'Create my will'"
          @gradientButtonClicked="signup"
          :bottomMargin="false"
        />
      </template>
      <template v-slot:image-text-row-two>
        <div class="section-padding" ref="estatePlanning">
          <ImageTextBanner
            :imageUrl="whitelabel.images.ourSolutionsEstatePlanningServices"
            :title="`<strong style='font-weight:500;'>Estate planning</strong>`"
            :paragraphOne="`Effective estate planning ensures that your loved ones are protected and your wishes are honoured. Creating your will is a cornerstone of your estate plan since it outlines 
            how your assets should be distributed after your death, and provides guidance on guardianship for minor children.
            <br /><br />
            Our online process provides clear, factual, 
            information and a personalised cost calculation and estate protection recommendation. If you have more complex needs, 
            our partnership with Old Mutual’s adviser network allows for detailed discussions tailored to your specific requirements. `"
            :reversed="true"
            :buttonText="'Create my will'"
            @gradientButtonClicked="signup"
            :bottomMargin="false"
          />
        </div>
      </template>

      <template v-slot:tabbed-content>
        <div
          class="section-padding"
          ref="estateProtection"
          id="estateProtection"
        >
          <TitleRow
            :title="'Estate Protection'"
            :description="`Our range of products protects your estate and supports your family, 
            covering administration costs, education, cash flow, and debt protection.`"
            :isSubtitle="true"
          />

          <TabbedContentComponent
            v-if="!isMobile"
            :tabTitles="[
              'EstateAssist',
              'TaxAssist',
              'EduAssist',
              'CashAssist',
              'DebtAssist',
            ]"
          >
            <template v-slot:tab-zero>
              <ImageTextBanner
                :imageUrl="estateAssistDetails.imageUrl"
                :title="estateAssistDetails.title"
                :paragraphOne="estateAssistDetails.paragraphOne"
                :reversed="estateAssistDetails.reversed"
                :buttonText="estateAssistDetails.buttonText"
                @gradientButtonClicked="signup"
                :bottomMargin="false"
              />
            </template>
            <template v-slot:tab-one>
              <ImageTextBanner
                :imageUrl="taxAssistDetails.imageUrl"
                :title="taxAssistDetails.title"
                :paragraphOne="taxAssistDetails.paragraphOne"
                :reversed="taxAssistDetails.reversed"
                :buttonText="taxAssistDetails.buttonText"
                @gradientButtonClicked="signup"
                :bottomMargin="false"
              />
            </template>
            <template v-slot:tab-two>
              <ImageTextBanner
                :imageUrl="eduAssistDetails.imageUrl"
                :title="eduAssistDetails.title"
                :paragraphOne="eduAssistDetails.paragraphOne"
                :reversed="eduAssistDetails.reversed"
                :buttonText="eduAssistDetails.buttonText"
                @gradientButtonClicked="signup"
                :bottomMargin="false"
              />
            </template>
            <template v-slot:tab-three>
              <ImageTextBanner
                :imageUrl="cashAssistDetails.imageUrl"
                :title="cashAssistDetails.title"
                :paragraphOne="cashAssistDetails.paragraphOne"
                :reversed="cashAssistDetails.reversed"
                :buttonText="cashAssistDetails.buttonText"
                @gradientButtonClicked="signup"
                :bottomMargin="false"
              />
            </template>
            <template v-slot:tab-four>
              <ImageTextBanner
                :imageUrl="debtAssistDetails.imageUrl"
                :title="debtAssistDetails.title"
                :paragraphOne="debtAssistDetails.paragraphOne"
                :reversed="debtAssistDetails.reversed"
                :buttonText="debtAssistDetails.buttonText"
                @gradientButtonClicked="signup"
                :bottomMargin="false"
              />
            </template>
          </TabbedContentComponent>
          <MobileTabbedContent
            v-else
            :accordionData="accordionData"
            @gradientButtonClicked="signup"
          />
        </div>
      </template>
      <template v-slot:image-text-row-three>
        <div class="section-padding" ref="estateAdministration">
          <ImageTextBanner
            :imageUrl="whitelabel.images.ourSolutionsEstateAdministration"
            :title="`<strong style='font-weight:500;'>Estate Administration</strong>`"
            :paragraphOne="`
            Administering an estate after losing a loved one is both emotional and complex. At Old Mutual, we manage every detail with care and expertise, 
            ensuring your wishes are honoured and your family is supported throughout the process.
            <br /><br />
          <span style='font-weight:500;'>With Old Mutual, you can trust that we’ll guide you every step of the way, providing peace of mind during a challenging time.</span>
            `"
            :reversed="true"
            :buttonText="'Create my will'"
            @gradientButtonClicked="signup"
            :bottomMargin="false"
          />
        </div>
      </template>
      <template v-slot:articles>
        <div class="section-padding">
          <ArticleTilesContainer :tiles="articleTiles" :articles="articles" />
        </div>
      </template>
    </Layout>
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
  </div>
</template>

<script>
import Breadcrumb from "../../common/Breadcrumb.vue";
import ImageTextBanner from "../ImageTextBanner.vue";
import TestimonialsSection from "../TestimonialsSection.vue";
import TabbedContentComponent from "../../common/TabbedContentComponent.vue";
import ArticleTilesContainer from "../articles/ArticleTilesContainer.vue";
import Layout from "../../common/layouts/Layout.vue";
import DefaultHeroBar from "../../common/DefaultHeroBar.vue";
import TitleRow from "../../common/TitleRow.vue";
import DynamicNavDrawer from "../../guest/DynamicNavDrawer.vue";
import DrawerSignUp from "../../guest/DrawerSignUp.vue";
import DrawerSignIn from "../../guest/DrawerSignIn.vue";
import MobileTabbedContent from "../how_it_works/MobileTabbedContent.vue";
import SuccessSnackbar from "../../common/SuccessSnackbar.vue";

export default {
  name: "HomeAlternative",
  components: {
    Breadcrumb,
    ImageTextBanner,
    TestimonialsSection,
    TabbedContentComponent,
    ArticleTilesContainer,
    Layout,
    DefaultHeroBar,
    TitleRow,
    DynamicNavDrawer,
    DrawerSignUp,
    DrawerSignIn,
    MobileTabbedContent,
    SuccessSnackbar,
  },
  metaInfo() {
    return {
      title: this.whitelabel.metaData.ourSolutions.title,
      meta: [
        {
          name: "description",
          content: this.whitelabel.metaData.ourSolutions.description,
        },
        {
          property: "og:title",
          content: this.whitelabel.metaData.ourSolutions.ogTitle,
        },
        {
          property: "og:image",
          content: this.whitelabel.metaData.ourSolutions.ogImage,
        },
        {
          property: "og:type",
          content: this.whitelabel.metaData.ourSolutions.ogType,
        },
        {
          property: "og:url",
          content: this.whitelabel.metaData.ourSolutions.ogUrl,
        },
        {
          property: "og:description",
          content: this.whitelabel.metaData.ourSolutions.description,
        },
        {
          property: "og:site_name",
          content: this.whitelabel.metaData.ourSolutions.ogSiteName,
        },
      ],
    };
  },
  data() {
    return {
      signUpDrawerOpen: false,
      signInDrawerOpen: false,
      showAlert: false,
      alertMessage: null,
      countryPattern: require("@/assets/shared/redesign/backgrounds/country-pattern.svg"),
      greenAccentOne: require("@/assets/shared/redesign/backgrounds/green-accent-1.svg"),
      greenAccentTwo: require("@/assets/shared/redesign/backgrounds/green-accent-2.svg"),
      purpleAccent: require("@/assets/shared/redesign/backgrounds/purple-accent.svg"),
      tribalPattern: require(`@/assets/old_mutual/homepage/generic.svg`),
      articleImages: {
        image1: require("@/assets/shared/redesign/articles/EstatePlanning.jpg"),
        image2: require("@/assets/shared/redesign/articles/articles2.svg"),
        image3: require("@/assets/shared/redesign/articles/articles3.svg"),
      },
    };
  },
  methods: {
    successResetPassword() {
      this.signInDrawerOpen = false;
      this.alertMessage =
        this.whitelabel.authentication.resetPassword.successMessage;
      this.showAlert = true;
    },
    drawerClosed() {
      this.signUpDrawerOpen = false;
    },
    signInDrawerClosed() {
      this.signInDrawerOpen = false;
    },
    quickStartCardLinkClicked(observer) {
      this.scrollIntoView(observer);
    },
    signup() {
      this.$router.push("/register");
    },
    loginClicked() {
      this.signUpDrawerOpen = false;
      this.signInDrawerOpen = true;
    },
    scrollIntoView(observer) {
      requestAnimationFrame(() => {
        this.$refs[observer].scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    },
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
    containers() {
      return [
        {
          name: "header",
          background: "countryPattern",
          class: "hero-banner",
        },
        {
          name: "image-text-row-one",
          background: "countryPattern",
          fadedRow: true,
          class: "our-solutions",
          accents: ["green-accent-1"],
          hr: true,
        },
        {
          name: "image-text-row-two",
          background: "accent",
          class: "our-solutions",
          accents: ["purple-accent-1"],
          hr: true,
        },
        {
          name: "tabbed-content",
          background: "accent",
          accents: ["green-accent-2"],
          class: "tabbed-content",
          hr: true,
        },
        {
          name: "image-text-row-three",
          class: "our-solutions",
          hr: true,
        },
        { name: "articles" },
      ];
    },

    countryPatternStyle() {
      if (!this.isMobile) {
        return {
          backgroundImage: `url(${this.countryPattern})`,
          backgroundSize: "cover",
        };
      }
    },
    tribalPatternStyle() {
      return {
        backgroundImage: `url(${this.tribalPattern})`,
        backgroundSize: "cover",
      };
    },
    taxAssistDetails() {
      return {
        imageUrl: this.whitelabel.images.ourSolutionsTaxAssist,
        title: `<span style="font-weight:700;font-size:28px;line-height:32px;color:#E9AB21;text-decoration:underline;">Tax</span><span style="font-weight:500;color:#282828;">Assist</span>`,
        paragraphOne: `
      TaxAssist is an additional benefit that can be added to your EstateAssist cover. It provides funds to settle outstanding taxes upon your death, preventing your family from needing to sell assets.
         </br /></br />
       <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
            <li>Different levels of cover are offered depending on your tax requirements.</li>
            <li>Premiums are fixed for the first year, with a 6% annual increase afterward.</li>
            <li>Available to South African residents aged 18-65 with a valid SA ID number, that meet the requirements of our simplified underwriting process.</li>
            <li>Cover stops if payments are discontinued.
            <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
        <strong>You get exclusive access to the TaxAssist benefit when you create your will through the Old Mutual online process.</strong>
        `,
        reversed: false,
        buttonText: "Create my will",
      };
    },
    estateAssistDetails() {
      return {
        imageUrl: this.whitelabel.images.ourSolutionsEstateAssist,
        title: `<span style="font-weight:700;font-size:28px;line-height:32px;color:#ED0080;text-decoration:underline;">Estate</span><span style="font-weight:500;color:#282828;">Assist</span>`,
        paragraphOne: `
      EstateAssist provides cover to manage the unexpected legal and administrative costs that arise after death, ensuring that your loved ones won’t have to sell assets to cover these expenses. 
         </br /></br />
       <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
            <li>Different levels of cover are offered depending on your needs.</li>
            <li>Covers executor fees, conveyancer fees, administration fees, and testamentary trust setup fees (if selected).</li>
            <li>Premiums are fixed for the first year, increasing by 6% annually thereafter.</li>
            <li>Available to South African residents aged 18-65 with a valid SA ID number, that meet the requirements of our simplified underwriting process.
            <li>Cover stops if payments are discontinued.</li>
            <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
        <strong>Get exclusive access to EstateAssist when you create your will through the Old Mutual online process.</strong>
        `,
        reversed: false,
        buttonText: "Create my will",
      };
    },
    debtAssistDetails() {
      return {
        imageUrl: this.whitelabel.images.ourSolutionsDebtAssist,
        title: `<span style="font-weight:700;font-size:28px;line-height:32px;color:#D65E23;text-decoration:underline;">Debt</span><span style="font-weight:500;color:#282828;">Assist</span>`,
        paragraphOne: `
      DebtAssist is an additional benefit that can be added to your EstateAssist cover. 
      It provides funds to settle outstanding debts upon your death, preventing your family from needing to sell assets. 
         </br /></br />
       <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
            <li>Different levels of cover are offered depending on your debt.</li>
        <li>Premiums are fixed for the first year, with a 6% annual increase afterward.</li>
        <li>Available to South African residents aged 18-65 with a valid SA ID number, 
          that meet the requirements of our simplified underwriting process.</li>
        <li>Cover stops if payments are discontinued.</li>
        <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
             <strong>You get exclusive access to the DebtAssist benefit when you create your will through the Old Mutual online process.</strong>
        `,
        reversed: false,
        buttonText: "Create my will",
      };
    },
    cashAssistDetails() {
      return {
        imageUrl: this.whitelabel.images.ourSolutionsCashAssist,
        title: `<span style="font-weight:700;font-size:28px;line-height:32px;color:#8ABA3E;text-decoration:underline;">Cash</span><span style="font-weight:500;color:#282828;">Assist</span>`,
        paragraphOne: `
        CashAssist is an additional benefit that can be added to your EstateAssist cover.  It offers immediate financial support to your family after your death, 
        ensuring they can manage daily expenses while your estate is settled. 
         </br /></br />
         <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
       <li>Different levels of cover are offered depending on your needs, typically offering enough for three months' worth of expenses.</li>
        <li>Payout is made within two weeks of submitting all required documents.</li>
        <li>Premiums are stable for the first year, with a 6% annual increase thereafter.</li>
        <li>Available to South African residents aged 18-65 with a valid SA ID number, that meet the requirements of our simplified underwriting process.</li>
        <li>Cover stops if payments are discontinued.</li>
        <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
             <strong>You get exclusive access to the CashAssist benefit when you create your will through the Old Mutual online process.</strong>
        `,
        reversed: false,
        buttonText: "Create my will",
      };
    },
    eduAssistDetails() {
      return {
        imageUrl: this.whitelabel.images.ourSolutionsEduAssist,
        title: `<span style="font-weight:700;font-size:28px;line-height:32px;color:#6087ED;text-decoration:underline;">Edu</span><span style="font-weight:500;color:#282828;">Assist</span>`,
        paragraphOne: `
          EduAssist is an additional benefit that can be added to your EstateAssist cover. 
          It ensures your children’s education continues without financial disruption if you pass away. 
         </br /></br />
     <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
         <li>Different levels of cover are offered depending on the requirements as relates to school-related expenses (fees, uniforms, stationery, transport).</li>
        <li>Payout is made each January to the nominated guardian or a testamentary trust until the child turns 18.</li>
        <li>Premiums remain stable for the first year, with a 6% annual increase thereafter.</li>
        <li>Available to parents aged 18-65 with a valid SA ID number, that meet the requirements of our simplified underwriting process.</li>
        <li>Cover stops if payments are discontinued.</li>
        <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
             <strong>You get exclusive access to EduAssist when you create yo.ur will through the Old Mutual online process</strong>
        `,
        reversed: false,
        buttonText: "Create my will",
      };
    },
    articleTiles() {
      return this.whitelabel.articleTiles;
    },
    articles() {
      return this.whitelabel.articles;
    },
    accordionData() {
      return this.whitelabel.ourSolutionsData;
    },
  },
  created() {
    if (this.$route.hash === "#estatePlanning") {
      this.scrollIntoView("estatePlanning");
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.main {
  background-color: #f9f9f9;
}
.content-container {
  width: clamp(300px, 95%, 1600px);
  z-index: 12;

  &.hr {
    width: 1280px;
    max-width: 60vw;
  }
}

.our-solutions-title-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;

  h1 {
    font-family: Montserrat;
    font-size: 28px;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: -0.0025em;
    text-align: center;
    margin-bottom: 24px;
  }
  p {
    font-family: Montserrat;
    font-size: 22px;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
    margin-bottom: 53px;
  }
}

.bread-crumbs-container {
  margin-top: 12px !important;
}

.fluid-container {
  padding: 0;
  margin: 0;
  &.create-your-will {
    max-height: 309px !important;
    position: relative;
    background-color: white;
    z-index: 12;
    .content-row {
      margin-top: unset;
    }
  }
}

.fade-row {
  position: relative; // Ensures proper gradient effect
  background: linear-gradient(
    to bottom,
    rgba(249, 249, 249, 0.2) 0%,
    rgba(249, 249, 249, 0.3) 15%,
    rgba(249, 249, 249, 0.4) 30%,
    rgba(249, 249, 249, 0.4) 45%,
    rgba(249, 249, 249, 0.7) 65%,
    rgba(249, 249, 249, 0.9) 85%,
    rgba(249, 249, 249, 1) 100%
  );
  z-index: 12;
}
.content-row {
  padding: 88px 0;
  margin-top: auto;
  &.hr {
    padding: 0;
  }

  &.calculator-banner {
    position: relative;
  }
}

.green-accent-1 {
  position: absolute;
  bottom: -140px;
  width: 150px;
  left: 0;
}
.green-accent-2 {
  position: absolute;
  top: -164px;
  width: 320px;
  left: 14px;
}
.purple-accent {
  position: absolute;
  top: -252px;
  width: 200px;
  right: 12px;
}

@media only screen and (min-width: 0px) and (max-width: 959px) {
  .content-container {
    margin: 0;
  }
  .content-row {
    padding: 52px 0;
  }
}
.edu {
  color: var(--v-education-blue-base);
}
.cost {
  color: var(--v-cost-orange-base);
}

.cash {
  color: var(--v-cash-green-base);
}

.debt {
  color: var(--v-debt-brown-base);
}

.estate {
  color: var(--v-estate-pink-base);
}
</style>
